/**
 * 사진 주소 → 목록용 작은 사진 주소.
 *
 * 'https://cdn/reviews/a.jpg' → 'https://cdn/reviews/thumbs/a.jpg'
 *
 * 왜 서버가 안 주고 여기서 만드나
 * -----------------------------
 * 처음에는 서버가 `imageThumbnails`로 함께 보냈다. 그런데 그 값이 응답의
 * 22.6%를 차지했다 — 기록 한 건에 455바이트, 300건이면 136KB다. 원본 주소에
 * 폴더 하나만 끼워 넣으면 나오는 값을 굳이 실어 보낸 셈이다.
 *
 * 규칙은 서버의 ImageOptimizer::thumbUrl()과 같다. 한쪽을 바꾸면 다른 쪽도
 * 바꿔야 한다. 폴더 이름은 'thumbs' 하나뿐이라 어긋날 여지는 작다.
 *
 * 파일이 실제로 있는지는 확인하지 않는다. 없으면 ListPhoto가 404를 보고
 * 원본으로 물러난다.
 */
const THUMB_DIR = 'thumbs'

export function thumbUrl(url: string): string {
  if (!url) return url

  try {
    const parsed = new URL(url)

    // 이미 썸네일이면 두 번 붙이지 않는다
    if (parsed.pathname.includes(`/${THUMB_DIR}/`)) return url

    const at = parsed.pathname.lastIndexOf('/')
    if (at < 0) return url

    parsed.pathname =
      parsed.pathname.slice(0, at) +
      `/${THUMB_DIR}` +
      parsed.pathname.slice(at)

    return parsed.toString()
  } catch {
    // 주소 형태가 아니면 손대지 않는다. 손대면 엉뚱한 경로가 된다.
    return url
  }
}
